import refs from '../helpers/refs'
import Form from '../helpers/form'
import '../atoms/a-input-date'
import '../atoms/a-input-select'
import '../atoms/a-input-text'

class CDealerApplicationForm {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)

    this.init()
  }

  init () {
    // Country/state behavior
    Form.handleCountryStateZip(this.$refs.countryDropdown)
    Form.handleCountrySubsidiary()

    this.component.querySelector('#kj-form').addEventListener('submit', (event) => {
      const isValid = this.validateForm()

      if (!isValid) {
        event.preventDefault()
      }

      return isValid
    })
  }

  validateForm () {
    const zipField = document.getElementById('zip-field')
    const emailField = document.getElementById('email-field')
    let formIsValid = true

    // change style of button so can tell it's been clicked
    document.querySelector('#submit-btn').setAttribute('disabled', true)
    document.querySelector('.please-wait').classList.remove('hidden')

    // Clear previous error messages
    Form.hideAllErrors()

    // Check required fields
    formIsValid = Form.validateRequiredFields(this.component)

    if (formIsValid) {
      if (!(formIsValid &&= Form.validZip(zipField.value))) {
        Form.showError(zipField.closest('.a-input-text'), 'Please input a valid zip code.')
      }

      // Can't get this to work with the same &&= operator as above. Don't know why. Not taking the time to figure it out.
      const emailIsValid = Form.validEmail(emailField.value)
      if (!emailIsValid) {
        Form.showError(emailField.closest('.a-input-text'), 'Please input a valid email address.')
        formIsValid = false
      }
    }

    // re-enable submit button
    document.querySelector('#submit-btn').removeAttribute('disabled')
    document.querySelector('.please-wait').classList.add('hidden')

    if (!formIsValid) {
      // Set focus on the first error field
      Form.focusFirstError(this.component.querySelector('#kj-form'))
    }

    return formIsValid
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-dealer-application-form')
    .forEach(el => new CDealerApplicationForm(el))
})
